module.exports = __webpack_public_path__ + "static/img/pc_pd_v3_1.e389ffb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/pc_pd_v3_1.png
// module id = prSu
// module chunks = 0